<template>
  <div class="tournaments-not-available" data-qe-id="tournaments-not-available">
    <t-container class="narrow-container">
      <div class="calendar"></div>
      <div class="content">
        <t-text v-html="md($t('tNotAvailable.main.text'))"></t-text>
      </div>
    </t-container>
  </div>
</template>

<script setup lang="ts">
import { marked } from 'marked'

function md(text: string) {
  return marked(text)
}
</script>

<style lang="less" scoped>
.tournaments-not-available {
  .narrow-container {
    display: flex;
    justify-items: center;
    justify-content: center;
    align-items: center;
    margin: 6em auto 7em;
  }
  .calendar {
    margin-right: 1.5em;
    width: 13.375em;
    height: 11.0625em;
    background: url('../assets/calendar_asset.png') center center no-repeat;
    background-size: contain;
  }
  .content {
    &::v-deep {
      .t-text *:first-child {
        margin-top: 0;
      }
      .t-text *:last-child {
        margin-bottom: 2em;
      }
      > *:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
